
import { Vue, Component, Prop } from "vue-property-decorator";

import PasswordSettings from "@/components/userSettings/PasswordSettings.vue";
import PageHeader from "@/components/page/PageHeader.vue";
import PaymentSettings from "@/components/userSettings/PaymentSettings.vue";
import UIButton from "@/components/button/ui-button.vue";
import DELETE_INDIVIDUAL_CONTRACTOR from "@/apollo/contractors/DeleteIndividualContractor.gql"
import RouteNames from "@/entities/RouteNames";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";




import Roles from "@/entities/Roles";
import { User } from "@/generated/graphql";

@Component({
  components: {
    PageHeader,
    PasswordSettings,
    PaymentSettings,
    UIButton,
  },
})
export default class Settings extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  processing: boolean = false;


  get contractorId(): any {
    // return this.$route.params.id;
    return this.currentUser.id

  }

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get isContractor(): boolean {
    return this.currentUser.role === Roles.CONTRACTOR;

  }

  get isPaymentSettingsShown(): boolean {
    return this.isAdmin;
  }

  get contractorFullName(): string {
    // if (!this.contractor) {
    //   return "";
    // }

    const firstName = this.currentUser.given_name;
    const lastName = this.currentUser.family_name;
    return `${firstName} ${lastName}`;
  }

  async deleteContractorFromDB(): Promise<void> {
    this.processing = true;

    try {
      await this.removeContractorRevoke();

      this.redirectToCompatyContractorsDB();
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`${this.contractorFullName} was deleted`)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.successMessage(e.message));
    } finally {
      this.processing = false;
    }
  }


  redirectToCompatyContractorsDB(): void {
    this.$router.push({
      name: RouteNames.COMPANY_DATABASE,
    });
  }
  deleteContractor(): void {
    this.$confirm({
      title: "Permanently Delete Your Account",
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm) => {
        if (confirm) {

          await this.deleteContractorFromDB();
        }
      },
    });
    return;
  }

  private removeContractorRevoke() {
    return this.$apollo.mutate({
      mutation: DELETE_INDIVIDUAL_CONTRACTOR,
      variables: {
        contractorId: this.contractorId,
        // companyId: this.company.id
      },
    });

  }
}



